import { MediaType } from '../MediaType';
import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

export const experimentalSynchronyJwt: ExperimentalQueries['experimentalSynchronyJwt'] = (
	_,
	{ contentId, draftShareId },
	{ network: { cfetch } },
) =>
	cfetch(`/wiki/rest/synchrony/1.0/token/${contentId}/generate?draftShareId=${draftShareId}`, {
		method: 'GET',
		headers: {
			'Content-Type': MediaType.JSON,
		},
	}).then(
		(response) => {
			if (response.ok) {
				return response.json().then((payload) => ({
					synchronyToken: payload.synchronyToken,
					configuredUrl: payload.configuredUrl,
					applicationId: payload.applicationId,
					synchronyExpiry: payload.synchronyExpiry,
				}));
			} else {
				throw 'Fail to get synchrony token';
			}
		},
		(err) => {
			if (err.response?.status === 412) {
				throw new Error('MIGRATED_NCS'); // Apollo is going to wrap the error and we're going to lose the original object and status code.
			} else {
				throw err;
			}
		},
	);
